function LabeledCheckbox({
  id = null,
  defaultChecked = false,
  checked = false,
  checkboxClass = null,
  onChange = null,
  labelText = null,
}) {
  return (
    <label htmlFor={id} className={`my-checkbox ${checkboxClass}`}>
      <div>
        <input type="checkbox" checked={checked} id={id} onChange={onChange} />
        <span className="checkmark"></span>
      </div>
      {labelText}
    </label>
  );
}

export { LabeledCheckbox };
